import React from 'react';
import { TabsContent } from '../ui/tabs';
import { Card, CardHeader, CardTitle, CardContent } from '../ui/card';
import { Button } from '../ui/button';
import { FileText } from 'lucide-react';

export function ReportsTab({ project, waterfallData, onGeneratePDF }) {
  return (
    <TabsContent value="reports">
      <Card className="rounded-sm border">
        <CardHeader className="pb-2">
          <CardTitle className="text-sm font-semibold uppercase tracking-wide">Reports</CardTitle>
        </CardHeader>
        <CardContent>
          <div className="space-y-4">
            <div className="p-4 border rounded-sm flex items-center justify-between">
              <div>
                <p className="font-medium">Investor Statement</p>
                <p className="text-sm text-muted-foreground">
                  {project.status === 'Sold' ? 'Generate PDF with JV waterfall calculation' : 'Generate capital position statement with full transaction ledger'}
                </p>
              </div>
              <Button
                onClick={onGeneratePDF}
                disabled={!waterfallData}
                className="bg-forest-500 hover:bg-forest-600 text-white rounded-sm uppercase text-xs"
                data-testid="generate-pdf-btn"
              >
                <FileText className="w-4 h-4 mr-2" /> Generate PDF
              </Button>
            </div>
            {!waterfallData && (
              <p className="text-sm text-amber-600">
                Note: To generate investor statement, ensure the project has a JV agreement.
              </p>
            )}
          </div>
        </CardContent>
      </Card>
    </TabsContent>
  );
}
